import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import Modal from 'react-bootstrap/Modal';
import Header from "./header";
import SideNav from "./sidenav";
import Loading from "../assets/images/loading.png";
import Back from "../assets/images/arrow2.png";
import User4 from "../assets/images/user4.jpg";


const Notification = () => {


    return (
        <div>
            <Header />
            <SideNav />

            <div class="WrapperArea">
                <div class="WrapperBox">
                    <div class="TitleBox">
                        <div>
                            <h4> <Link to="/dashboard" > <img src={Back} /></Link> Notification</h4>
                        </div>
                    </div>
                    <div class="Small-Wrapper">
                        <div class="NotificationArea">
                            <ul>
                                <li>
                                    <figure> <img src={User4} /></figure>
                                    <h4>Anu Pratihar</h4>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                    <h6>24 Feb '21 , 2:00 PM</h6>
                                </li>
                                <li>
                                    <figure> <img src={User4} /></figure>
                                    <h4>Anu Pratihar</h4>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                    <h6>24 Feb '21 , 2:00 PM</h6>
                                </li>
                                <li>
                                    <figure> <img src={User4} /></figure>
                                    <h4>Anu Pratihar</h4>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                    <h6>24 Feb '21 , 2:00 PM</h6>
                                </li>
                                <li>
                                    <figure> <img src={User4} /></figure>
                                    <h4>Anu Pratihar</h4>
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                                    <h6>24 Feb '21 , 2:00 PM</h6>
                                </li>
                            </ul>
                        </div>
                        <div class="text-center">
                            <button class="LoadingNotification"><img src={Loading} /> Loading Notification</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Notification